module.exports = __webpack_public_path__ + "media/images/logo-alpha-5d7063a31d596ddc1e2570bc49a474cd.png";